export let HOST = "http://localhost:4000";
if (!window.location.hostname.includes('localhost')) {
  HOST = "https://api.b2bwhm.devserver.london";
}
// export const HOST = "https://api.b2b-wallet-interactive-map.devserver.london";